module.exports = __webpack_public_path__ + "media/images/correct-df43cd63866f52f9b42c2b9471668e9a.svg";